import { render, staticRenderFns } from "./setUserOrgAction.vue?vue&type=template&id=28f9b49a"
import script from "./setUserOrgAction.vue?vue&type=script&lang=js"
export * from "./setUserOrgAction.vue?vue&type=script&lang=js"
import style0 from "./setUserOrgAction.vue?vue&type=style&index=0&id=28f9b49a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports